"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MSG_INTERNAL_RECEIVE_SIGN_OUT = exports.MSG_INTERNAL_RECEIVE_PASSWORD = exports.MSG_INTERNAL_REQUEST_PASSWORD = void 0;
/*
 * Requests messages
 */
exports.MSG_INTERNAL_REQUEST_PASSWORD = 'INTERNAL_REQUEST_PASSWORD';
/*
 * Responses messages
 */
exports.MSG_INTERNAL_RECEIVE_PASSWORD = 'INTERNAL_RECEIVE_PASSWORD';
exports.MSG_INTERNAL_RECEIVE_SIGN_OUT = 'INTERNAL_RECEIVE_SIGN_OUT';
